// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: "https://api-lms-envx.project-ashton.com/",
  baseUrl: "https://api-lms-envx.project-ashton.com/v2/user_management",
  resetPassword: "/change_password/",
  login: "https://api-lms-envx.project-ashton.com/v2/user_authentication/get_token",
  ForgotPassworLink: "/forgot_password_link/",
  ForgotPasswor: "/reset_password",
  passwordGuildelines: "/get_passwordguidelines",
  redirectUrl: "https://lmsrc.dev.dhr-lsdigital.com/#/landing",
  lamdaUrl: "https://7b3lp7v6a9.execute-api.eu-central-1.amazonaws.com/dev/um-extended-apis/",
  authentication: "https://api-lms-envx.project-ashton.com/v2/auth_management/",
  lmsEndpoint:"https://vgaf3eyfw4.execute-api.eu-central-1.amazonaws.com/dev/v1/",
  cookieExpiryDays: 7,
  identityProvider:"lms-envx",
  opco:"lms-rc-dev",
  local: false,
  getUserTypeUri: 'user-management/get-user-userType',
  auth0: {
    authority: 'https://dev.login.lifesciences.danaher.com',
    clientId: 'fFR5Q3F3kGaOWIzNI2ueNichhKvtnjIr',
    scope: 'openid profile email offline_access'
  }
};
